<script setup>
import Text from './Types/Text'
import Select from './Types/Select'
import Boolean from './Types/Boolean'
import { useBreadStore } from '@bread/js/store'

const emits = defineEmits(['filter'])

const store = useBreadStore()

const filterUpdate = () => {
  emits('filter')
}

</script>

<template>
  <div
    v-if="store.resource"
    v-for="filter in store.getFilters()"
    :key="filter.uuid"
  >
    <Select v-if="filter.type === 'select'" :filter="filter" @change="filterUpdate"/>
    <Text v-if="filter.type === 'text'" :filter="filter" @change="filterUpdate"/>
    <Boolean v-if="filter.type === 'boolean'" :filter="filter" @change="filterUpdate"/>
  </div>
</template>
